import LockupOnLight from "@/assets/golfrecruit-lockup-light.svg";
import LockupOnDark from "@/assets/golfrecruit-lockup-dark.svg";
import { useBranding } from "@/hooks/useBranding";
import { cn } from "@/lib/utils";

interface OnboardingBrandProps {
  surface?: "light" | "dark";
  className?: string;
}

/** Uses the same customer wordmark and golfrecruit.ai fallback as the app header. */
export function OnboardingBrand({ surface = "light", className }: OnboardingBrandProps) {
  const { branding } = useBranding();
  const customLogo = branding?.headerLogoUrl || null;
  const logoSrc = customLogo || (surface === "dark" ? LockupOnDark : LockupOnLight);

  return (
    <div
      className={cn(
        "inline-flex h-10 items-center",
        customLogo && surface === "dark" && "rounded-xl bg-white/95 px-2.5 shadow-sm",
        className
      )}
    >
      <img src={logoSrc} alt="golfrecruit.ai" className="h-7 w-auto max-w-[180px] object-contain" />
    </div>
  );
}
